import * as React from "react";
import { forwardRef } from "react";
const SvgCloseCircle = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 13, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 6.5a6.01 6.01 0 0 1 6-6 6.007 6.007 0 0 1 6 6 6.007 6.007 0 0 1-6 6 6.007 6.007 0 0 1-6-6m1.5 0a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0m5.56 2.122L6 7.56 4.94 8.622a.75.75 0 0 1-1.226-.819.8.8 0 0 1 .163-.243L4.94 6.5 3.877 5.438a.75.75 0 1 1 1.062-1.06L6 5.438l1.06-1.06a.75.75 0 0 1 1.061 1.06l-1.06 1.06 1.06 1.06a.75.75 0 1 1-1.06 1.063" }));
const ForwardRef = forwardRef(SvgCloseCircle);
export { ForwardRef as ReactComponent };
